import { useEffect } from "react";
import { css } from "@emotion/react";
import { motion, useAnimation } from "framer-motion";

import CastItem, { CastItemProps } from "./CastItem";
import {
  sugisaki_hana_comment,
  sugisaki_hana_profile,
  hagiwara_riku_comment,
  hagiwara_riku_profile,
  toyohara_kousuke_comment,
  toyohara_kousuke_profile,
  yasuda_ken_comment,
  yasuda_ken_profile,
} from "../../constants/comments";
import { useInView } from "react-intersection-observer";
import { fadeInAnimation, fadeInVariants } from "../../constants/animations";

const sugisakiHana: CastItemProps = {
  imgPath: "/img/sugisaki-hana.png",
  castImgPath: "/img/cast-sugisaki-hana.png",
  castImgSize: 80,
  castImgSizeSP: 60,
  cbImgPath: "/img/cb_sugisaki-hana.jpg",
  comment: sugisaki_hana_comment,
  profile: sugisaki_hana_profile,
};

const hagiwaraRiku: CastItemProps = {
  imgPath: "/img/hagiwara-riku.png",
  castImgPath: "/img/cast-hagiwara-riku.png",
  castImgSize: 90,
  castImgSizeSP: 70,
  cbImgPath: "/img/cb_hagiwara-riku.jpg",
  comment: hagiwara_riku_comment,
  profile: hagiwara_riku_profile,
};

const toyoharaKousuke: CastItemProps = {
  imgPath: "/img/toyohara-kousuke.png",
  castImgPath: "/img/cast-toyohara-kousuke.png",
  castImgSize: 90,
  castImgSizeSP: 70,
  cbImgPath: "/img/cb_toyohara-kousuke.jpg",
  comment: toyohara_kousuke_comment,
  profile: toyohara_kousuke_profile,
};

const yasudaKen: CastItemProps = {
  imgPath: "/img/yasuda-ken.png",
  castImgPath: "/img/cast-yasuda-ken.png",
  castImgSize: 80,
  castImgSizeSP: 60,
  cbImgPath: "/img/cb_yasuda-ken.jpg",
  comment: yasuda_ken_comment,
  profile: yasuda_ken_profile,
};

const Cast = () => {
  const controls = useAnimation();
  const [ref, inView] = useInView();
  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [inView, controls]);

  return (
    <motion.div
      css={mainStyle}
      id="cast"
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={fadeInVariants}
    >
      <div css={titleStyle}>CAST</div>
      <div css={castItemWrapperStyle(40)}>
        <CastItem {...sugisakiHana} />
      </div>
      <div css={castItemWrapperStyle(20)}>
        <CastItem {...hagiwaraRiku} />
      </div>
      <div css={castItemWrapperStyle(20)}>
        <CastItem {...toyoharaKousuke} />
      </div>
      <div css={castItemWrapperStyle(20)}>
        <CastItem {...yasudaKen} />
      </div>
    </motion.div>
  );
};

const spSize = 768;

const mainStyle = css`
  position: relative;
  width: 100%;
  padding: 40px 0 60px;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: ${spSize}px) {
    padding: 30px 0 40px;
  }
`;

const titleStyle = css`
  font-size: 35px;
  font-weight: 500;
  letter-spacing: 0.075em;

  @media (max-width: ${spSize}px) {
    font-size: 20px;
    font-weight: 400;
  }
`;

const castItemWrapperStyle = (marginTop: number) => css`
  margin-top: ${marginTop}px;
`;

export default Cast;
